
import React, { useEffect, useState } from "react";
import "../Styles/Analytics.css";
import { useSelector } from "react-redux";
import api from "../Component/Api";

 export default function Analytics() {
  const business = useSelector((state) => state.auth.business);

  const [tapStats, setTapStats] = useState(null);
  const [clickStats, setClickStats] = useState(null);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchAnalytics = async () => {
      if (!business?._id || !business?.slug) {
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        setError("");

        const [tapResponse, clickResponse] = await Promise.all([
          api.get(`/tap-stats/${business.slug}`),
          api.get(`/click-analytics/${business._id}`),
        ]);

        setTapStats(tapResponse.data);
        setClickStats(clickResponse.data);

        console.log("Tap stats:", tapResponse.data);
        console.log("Click stats:", clickResponse.data);
      } catch (err) {
        console.error("Failed to load analytics:", err);

        setError(
          err.response?.data?.message ||
            "Failed to load analytics."
        );
      } finally {
        setLoading(false);
      }
    };

    fetchAnalytics();
  }, [business?._id, business?.slug]);

  const taps = tapStats?.data || {};
  const clickData = clickStats || {};

  const topLinks = clickData.topLinks || [];
  const recentActivity = clickData.recentActivity || [];

  const totalClicks =
    clickData.totalClicks ??
    clickData.overview?.totalClicks ??
    0;

  const topLink = topLinks.length > 0 ? topLinks[0] : null;

  /* --------------------------------
     LOADING
  -------------------------------- */

  if (loading) {
    return (
      <div className="cc-analytics-page">
        <div className="cc-analytics-loading">
          <div className="cc-analytics-loading-spinner"></div>
          <p>Loading analytics...</p>
        </div>
      </div>
    );
  }

  /* --------------------------------
     ERROR
  -------------------------------- */

  if (error) {
    return (
      <div className="cc-analytics-page">
        <div className="cc-analytics-error">
          <h3>Unable to load analytics</h3>
          <p>{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="cc-analytics-page">

      {/* HEADER */}

      <header className="cc-analytics-header">

        <div className="cc-analytics-header-content">

          <p className="cc-analytics-eyebrow">
            ANALYTICS
          </p>

          <h1>Your activity</h1>

          <p className="cc-analytics-subtitle">
            See how people are interacting with your
            ClusterClear wristband.
          </p>

        </div>

        <div className="cc-analytics-live-status">
          <span></span>
          Live data
        </div>

      </header>


      {/* WRISTBAND ACTIVITY */}

      <section className="cc-analytics-section">

        <div className="cc-analytics-section-heading">

          <div>
            <h2>Wristband activity</h2>

            <p>
              How often people are opening your
              ClusterClear profile.
            </p>
          </div>

        </div>


        <div className="cc-analytics-stat-grid">

          <div className="cc-analytics-stat-card">
            <span className="cc-analytics-stat-label">
              Total taps
            </span>

            <strong className="cc-analytics-stat-value">
              {taps.total ?? 0}
            </strong>

            <p>All-time wristband taps</p>
          </div>


          <div className="cc-analytics-stat-card">
            <span className="cc-analytics-stat-label">
              Today
            </span>

            <strong className="cc-analytics-stat-value">
              {taps.today ?? 0}
            </strong>

            <p>Taps today</p>
          </div>


          <div className="cc-analytics-stat-card">
            <span className="cc-analytics-stat-label">
              This week
            </span>

            <strong className="cc-analytics-stat-value">
              {taps.thisWeek ?? 0}
            </strong>

            <p>Monday to today</p>
          </div>


          <div className="cc-analytics-stat-card">
            <span className="cc-analytics-stat-label">
              This month
            </span>

            <strong className="cc-analytics-stat-value">
              {taps.thisMonth ?? 0}
            </strong>

            <p>Taps this month</p>
          </div>

        </div>

      </section>


      {/* LINK ACTIVITY */}

      <section className="cc-analytics-section cc-analytics-link-section">

        <div className="cc-analytics-section-heading">

          <div>
            <h2>Link activity</h2>

            <p>
              See which links people are interacting
              with after opening your profile.
            </p>
          </div>

        </div>


        <div className="cc-analytics-click-grid">

          <div className="cc-analytics-card cc-analytics-click-card">

            <div className="cc-analytics-card-header">
              <h3>Total link clicks</h3>

              <p>
                All-time clicks on your profile links.
              </p>
            </div>

            <strong className="cc-analytics-large-stat">
              {totalClicks}
            </strong>

          </div>


          <div className="cc-analytics-card cc-analytics-click-card">

            <div className="cc-analytics-card-header">
              <h3>Top link</h3>

              <p>
                Your most clicked destination.
              </p>
            </div>

            <div className="cc-analytics-top-highlight">

              <strong>
                {topLink?.name || "No clicks yet"}
              </strong>

              <span>
                {topLink
                  ? `${topLink.clicks} clicks`
                  : "Start sharing your profile"}
              </span>

            </div>

          </div>

        </div>

      </section>


      {/* TOP LINKS */}

      <section className="cc-analytics-card cc-analytics-list-card">

        <div className="cc-analytics-card-header">

          <h3>Top links</h3>

          <p>
            Your most clicked destinations.
          </p>

        </div>


        <div className="cc-analytics-top-links">

          {topLinks.length === 0 ? (

            <div className="cc-analytics-empty">

              <div className="cc-analytics-empty-icon">
                ↗
              </div>

              <h4>No link clicks yet</h4>

              <p>
                When someone clicks a link on your
                ClusterClear profile, it will appear here.
              </p>

            </div>

          ) : (

            topLinks.map((link, index) => {

              const highestClicks =
                topLinks[0]?.clicks || 1;

              const percentage =
                (link.clicks / highestClicks) * 100;

              return (
                <div
                  className="cc-analytics-top-link"
                  key={link.type || link.name}
                >

                  <div className="cc-analytics-rank">
                    {String(index + 1).padStart(2, "0")}
                  </div>

                  <div className="cc-analytics-link-content">

                    <div className="cc-analytics-link-info">

                      <span>
                        {link.name}
                      </span>

                      <strong>
                        {link.clicks}
                      </strong>

                    </div>

                    <div className="cc-analytics-link-bar">
                      <span
                        style={{
                          width: `${percentage}%`,
                        }}
                      />
                    </div>

                  </div>

                </div>
              );
            })

          )}

        </div>

      </section>


      {/* RECENT ACTIVITY */}

      <section className="cc-analytics-card cc-analytics-list-card">

        <div className="cc-analytics-card-header">

          <h3>Recent activity</h3>

          <p>
            The latest link interactions with your profile.
          </p>

        </div>


        <div className="cc-analytics-activity-list">

          {recentActivity.length === 0 ? (

            <div className="cc-analytics-empty">

              <div className="cc-analytics-empty-icon">
                •
              </div>

              <h4>No activity yet</h4>

              <p>
                Your latest link clicks will appear here.
              </p>

            </div>

          ) : (

            recentActivity.map((activity, index) => {

              const formattedType =
                activity.type
                  ?.replace(/_/g, " ")
                  ?.replace(/\b\w/g, (char) =>
                    char.toUpperCase()
                  );

              return (
                <div
                  className="cc-analytics-activity"
                  key={`${activity.type}-${activity.time}-${index}`}
                >

                  <div className="cc-analytics-activity-icon">
                    {formattedType?.charAt(0) || "•"}
                  </div>

                  <div className="cc-analytics-activity-info">

                    <strong>
                      {activity.text}
                    </strong>

                    <span>
                      {formattedType}
                    </span>

                  </div>

                  <time>
                    {activity.time
                      ? new Date(
                          activity.time
                        ).toLocaleString("en-GB", {
                          day: "numeric",
                          month: "short",
                          hour: "2-digit",
                          minute: "2-digit",
                        })
                      : ""}
                  </time>

                </div>
              );
            })

          )}

        </div>

      </section>

    </div>
  );
}



